const PlaceholderManagementType = {
  RANGEPLANPRODUCT: 'RANGEPLANPRODUCT',
  PRODUCT_TAB_LIST: 'PRODUCT_TAB_LIST',
  SET_FILTERDATA: 'SET_FILTERDATA',
  UPDATE_PRODUCTLIST: 'UPDATE_PRODUCTLIST',
  GET_SAMPLE_TRACKING_PRODUCT_LISTING: 'GET_SAMPLE_TRACKING_PRODUCT_LISTING',
  SET_CRITICAL_PATH_CUSTOM_SECTIONS: 'SET_CRITICAL_PATH_CUSTOM_SECTIONS',
  SET_MEASUREMENT_SYSTEM_MASTER: 'SET_MEASUREMENT_SYSTEM_MASTER',
  PRODUCT_LIST_CATEGORY: 'PRODUCT_LIST_CATEGORY',
  PRODUCT_LIST_PRODUCT_TYPE: 'PRODUCT_LIST_PRODUCT_TYPE',
  PRODUCTLIST_FETCH_REFERENCE_SUPPLIER: 'PRODUCTLIST_FETCH_REFERENCE_SUPPLIER',
  PRODUCT_LIST_COMPANY_USERS: 'PRODUCT_LIST_COMPANY_USERS',
  PRODUCT_LIST_GET_ALL_PRODUCT_STATUS_MASTER: 'PRODUCT_LIST_GET_ALL_PRODUCT_STATUS_MASTER',
  PRODUCT_LIST_CUSTOM_ATTRIBUTE_LIST: 'PRODUCT_LIST_CUSTOM_ATTRIBUTE_LIST',
  PRODUCT_GROUP: 'PRODUCT_GROUP',
  UPDATE_PRODUCT_LIST: 'UPDATE_PRODUCT_LIST',
  RP_PRODUCT_INFORMATION: 'RP_PRODUCT_INFORMATION',
  GET_RANGE_PLAN_LOGS: 'GET_RANGE_PLAN_LOGS',
  CLEAR_LOGS_REDUCER: 'CLEAR_LOGS_REDUCER',
  RP_PRODUCT_INFORMATION_UNMOUNT: 'RP_PRODUCT_INFORMATION_UNMOUNT',
  CLEAR_FILTER_SELECTED_DATA: 'CLEAR_FILTER_SELECTED_DATA',

  // Range Plan Card View Types
  GET_RANGE_PLAN_CARDS: 'GET_RANGE_PLAN_CARDS',
  SET_RANGE_PLAN_CARDS: 'SET_RANGE_PLAN_CARDS',
  ADD_RANGE_PLAN_CARD: 'ADD_RANGE_PLAN_CARD',
  UPDATE_RANGE_PLAN_CARD: 'UPDATE_RANGE_PLAN_CARD',
  DELETE_RANGE_PLAN_CARD: 'DELETE_RANGE_PLAN_CARD',
  DUPLICATE_RANGE_PLAN_CARD: 'DUPLICATE_RANGE_PLAN_CARD',
  ARCHIVE_RANGE_PLAN_CARD: 'ARCHIVE_RANGE_PLAN_CARD',
  ARCHIVE_RANGE_PLAN_CARDS: 'ARCHIVE_RANGE_PLAN_CARDS',
  PIN_RANGE_PLAN_CARD: 'PIN_RANGE_PLAN_CARD',
  ACTIVE_INACTIVE_RANGE_PLAN_CARD: 'ACTIVE_INACTIVE_RANGE_PLAN_CARD',
  GET_RANGE_PLAN_CARD_DETAIL: 'GET_RANGE_PLAN_CARD_DETAIL',
  CLEAR_RANGE_PLAN_CARD_DETAIL: 'CLEAR_RANGE_PLAN_CARD_DETAIL',
  SET_RANGE_PLAN_CARD_LOADING: 'SET_RANGE_PLAN_CARD_LOADING',
  SET_RANGE_PLAN_CARD_FILTER: 'SET_RANGE_PLAN_CARD_FILTER',
  CLEAR_RANGE_PLAN_CARD_FILTER: 'CLEAR_RANGE_PLAN_CARD_FILTER',
  CLEAR_RANGE_PLAN_CARDS: 'CLEAR_RANGE_PLAN_CARDS',
  GET_CUSTOM_SECTION_DATA: 'GET_CUSTOM_SECTION_DATA',
  GET_CUSTOM_SECTION_DATA_ERROR: 'GET_CUSTOM_SECTION_DATA_ERROR',
  GET_ALL_SECTION_COLUMNS: 'GET_ALL_SECTION_COLUMNS',
  TOGGLE_COLUMN_TOTAL_SCOPE: 'TOGGLE_COLUMN_TOTAL_SCOPE',
  APPLY_COLUMN_TOTAL_DELTA: 'APPLY_COLUMN_TOTAL_DELTA',
  SET_COLUMN_TOTALS_LOADING: 'SET_COLUMN_TOTALS_LOADING',
  SET_COLUMN_TOTALS_SUCCESS: 'SET_COLUMN_TOTALS_SUCCESS',
};

export default PlaceholderManagementType;
